import EIVAPI from "api/eiv";

const getEIVsChartData = async (facility) => {
  try {
    const lastWeekRes = await EIVAPI.GetLastWeekForFacility(facility);
    const { week: currentWeek, year } = lastWeekRes.data;

    const startWeek = currentWeek - 8;
    const weeks = Array.from({ length: 8 }, (_, i) => i + startWeek + 1);

    const labels = [];
    const billed = [];
    const beforeDED = [];
    const afterDED = [];
    const beforededPercentages = [];
    const afterdedPercentages = [];

    for (const week of weeks) {
      try {
        const response = await EIVAPI.GetWeeklyFacilityMetrics(facility, week, year);
        const res = response.data;

        console.log(`Week ${week} response:`, res);

        labels.push(`Week ${week}`);
        billed.push(Number(res.total_charge || 0));
        beforeDED.push(Number(res.total_eiv_without_ded || 0));
        afterDED.push(Number(res.total_eiv_with_ded_and_oop || 0));
        beforededPercentages.push(res.beforededpercentage || 0);
        afterdedPercentages.push(res.afterdedpercentage || 0);
      } catch (error) {
        console.warn(`Missing data for week ${week}`, error);
        labels.push(`Week ${week}`);
        billed.push(0);
        beforeDED.push(0);
        afterDED.push(0);
        beforededPercentages.push(0);
        afterdedPercentages.push(0);
      }
    }

    const datasets = [
      { label: "Billed", color: "info", data: billed },
      {
        label: "Before DED",
        color: "dark",
        data: beforeDED,
        percentages: beforededPercentages,
      },
    ];
    
    const hasAfterDEDData = afterDED.some((val) => val > 0);
    if (hasAfterDEDData) {
      datasets.push({
        label: "After DED",
        color: "primary",
        data: afterDED,
        percentages: afterdedPercentages,
      });
    }
    const chart = { labels, datasets };

    console.log("Final EIV Chart Data:", chart);
    return chart;
  } catch (error) {
    console.error("Error initializing EIV chart data:", error);
    return {
      labels: [],
      datasets: [],
    };
  }
};

export const fetchWeeklyMetrics = async (facility, week, year) => {
  const response = await EIVAPI.GetWeeklyFacilityMetrics(facility, week, year);
  return response.data;
};

export default getEIVsChartData;
